/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Pregnancy_Physio_TermsInputs */

const en_service_type_pregnancy_physio_terms = /** @type {(inputs: Service_Type_Pregnancy_Physio_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pregnancy, postnatal, postpartum, diastasis recti, c section, scar`)
};

const pl_service_type_pregnancy_physio_terms = /** @type {(inputs: Service_Type_Pregnancy_Physio_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ciąża, po porodzie, rozejście mięśni brzucha, rozstęp, okołoporodowa, cesarka, blizna`)
};

/**
* | output |
* | --- |
* | "pregnancy, postnatal, postpartum, diastasis recti, c section, scar" |
*
* @param {Service_Type_Pregnancy_Physio_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_pregnancy_physio_terms = /** @type {((inputs?: Service_Type_Pregnancy_Physio_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Pregnancy_Physio_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_pregnancy_physio_terms(inputs)
	return en_service_type_pregnancy_physio_terms(inputs)
});